import { createSelector } from 'reselect';
import { selectAppDomain, AppState, selectCustomerType } from '@buy-viasat/redux/src/app';
import { validateEmail, validateMobileNumber, validatePhone, validateRequired } from '../Checkout/validations';
import { phoneNumberRegex, zipCodeRegex } from '@buy-viasat/utils';
import { selectPersonalInformationDomain } from '@buy-viasat/redux/src/personal-information';
import { selectAddressDomain, validateZip } from '@buy-viasat/redux/src/address';
import { selectBusinessInformationDomain } from '@buy-viasat/redux/src/business-information';
import { Country, CustomerType } from '@buy-viasat/redux/src/app/types';

const selectPersonalInformationValidation = createSelector(
  [
    selectPersonalInformationDomain,
    selectBusinessInformationDomain,
    selectAppDomain,
    selectAddressDomain,
    selectCustomerType,
  ],
  (
    { firstName, lastName, email, phone, mobileNumber },
    { accountHolder },
    appState: AppState,
    addressState,
    customerType,
  ) => {
    const isOrganization = customerType === CustomerType.B;
    let isValid;

    if (isOrganization) {
      isValid =
        validateRequired(accountHolder.firstName).valid &&
        validateRequired(accountHolder.lastName).valid &&
        validateRequired(accountHolder.email).valid &&
        validatePhone(accountHolder.phone, phoneNumberRegex[Country.US]).valid &&
        validateMobileNumber(accountHolder.mobileNumber, phoneNumberRegex[Country.US]).valid;
    } else {
      isValid =
        validateRequired(firstName.value).valid &&
        validateRequired(lastName.value).valid &&
        validateEmail(email.value).valid &&
        validatePhone(phone.value, phoneNumberRegex[Country.US]).valid &&
        validateMobileNumber(mobileNumber.value, phoneNumberRegex[Country.US]).valid;
    }

    const billingAddressValid =
      addressState.billingAddressEqualsServiceAddress ||
      (validateRequired(addressState.billingAddress.addressLines.value[0]).valid &&
        validateZip(addressState.billingAddress.postalCode.value).valid);
    const shippingAddressValid =
      addressState.shippingAddressEqualsServiceAddress ||
      (validateRequired(addressState.shippingAddress.addressLines.value[0]).valid &&
        validateZip(addressState.shippingAddress.postalCode.value).valid);

    return isValid && billingAddressValid && shippingAddressValid;
  },
);

export { selectPersonalInformationValidation };
